export enum EventLabels {
  SL_Splash = "SL_Splash",
  SL_Splash_Done = "SL_Splash_Done",
  SL_Login_Email = "SL_Login_Email",
  SL_Login_Email_Done = "SL_Login_Email_Done",
  CTA_LOGIN = "CTA_LOGIN",
  CTA_Email_Key = "CTA_Email_Key",
  CTA_Mobile_Key = "CTA_Mobile_Key",
  SL_OTP = "SL_OTP",
  SL_OTP_Done = "SL_OTP_Done",
  CTA_ResendOTP = "CTA_ResendOTP",
  CTA_Submit_OTP = "CTA_Submit_OTP",
  SL_PIIdetail = "SL_PIIdetail",
  SL_PIIdetail_Done = "SL_PIIdetail_Done",
  CTA_Memberships = "CTA_Memberships",
  CTA_Verify_Email = "CTA_Verify_Email",
  CTA_Verify_Mobile = "CTA_Verify_Mobile",
  SL_Dashboard = "SL_Dashboard",
  SL_Dashboard_Done = "SL_Dashboard_Done",
  CTA_Redeem = "CTA_Redeem",
  CTA_RedeemNow = "CTA_RedeemNow",
  CTA_MembershipsChange = "CTA_MembershipsChange",
  CTA_Category = "CTA_Category",
  CTA_Generate_Feedback = "CTA_Generate_Feedback",
  CTA_Feedback_Difficulty = "CTA_Feedback_Difficulty",
  CTA_Feedback_Rating = "CTA_Feedback_Rating",
  ONPG_Feedback_Reason = "ONPG_Feedback_Reason",
  SL_Offer_Description_Offer = "SL_Offer_Description_Offer",
  CTA_Confirm_Booking_Offer = "CTA_Confirm_Booking_Offer",
  SL_Offer_detail = "SL_Offer_detail",
  SL_Offer_detail_Done = "SL_Offer_detail_Done",
  CTA_Quota = "CTA_Quota",
  CTA_Start_Booking = "CTA_Start_Booking",
  SL_Facility = "SL_Facility",
  SL_Facility_Done = "SL_Facility_Done",
  CTA_Boking = "CTA_Boking",
  SL_Summary = "SL_Summary",
  SL_Summary_Done = "SL_Summary_Done",
  SL_Benefit_Success = "SL_Benefit_Success",
  SL_Benefit_Success_Done = "SL_Benefit_Success_Done",
  SL_Benefit_Coupon = "SL_Benefit_Coupon",
  SL_Benefit_Coupon_Done = "SL_Benefit_Coupon",
  SL_Benefit_Coupon_Success_Done = "SL_Benefit_Coupon_Success_Done",
  CTA_Dashboard = "CTA_Dashboard",
  CTA_History = "CTA_History",
  CTA_Redirect_Partner = "CTA_Redirect_Partner",
  CTA_Profile = "CTA_Profile",
  CTA_Add_Membership = "CTA_Add_Membership",
  CTA_Search = "CTA_Search",
  ONPG_Recent_Search = "ONPG_Recent_Search",
  ONPG_Result_Search = "ONPG_Result_Search",
  CTA_Hamburger = "CTA_Hamburger",
  CTA_Supprt = "CTA_Supprt",
  CTA_Settings = "CTA_Settings",
  CTA_Logout = "CTA_Logout",
  SL_History = "SL_History",
  SL_History_Done = "SL_History_Done",
  CTA_History_Benefit_Card = "CTA_History_Benefit_Card",
  CTA_Filter = "CTA_Filter",
  SL_History_Detail = "SL_History_Detail",
  SL_History_Detail_Done = "SL_History_Detail_Done",
  CTA_Feedback = "CTA_Feedback",
  CTA_Brand = "CTA_Brand",
  CTA_Thriwe = "CTA_Thriwe",
  CTA_Brand_Reason = "CTA_Brand_Reason",
  CTA_Thriwe_Reason = "CTA_Thriwe_Reason",
  SL_Feedback_Submit = "SL_Feedback_Submit",
  SL_Feedback_Submit_Done = "SL_Feedback_Submit_Done",
  CTA_Cancel_Booking = "CTA_Cancel_Booking",
  SL_Feedback = "SL_Feedback",
  SL_Feedback_Done = "SL_Feedback_Done",
  CTA_Savings = "CTA_Savings",
  SL_Savings = "SL_Savings",
  SL_Savings_Done = "SL_Savings_Done",
  CTA_Last_Month = "CTA_Last_Month",
  CTA_Custom = "CTA_Custom",
  CTA_Terms_and_Condition = "CTA_Terms_and_Condition",
  CTA_Redemption = "CTA_Redemption",
  CTA_Details_Quota = "CTA_Details_Quota",

  CTA_Default_Membership = "CTA_Default_Membership",

  CTA_Edit_Profile = "CTA_Edit_Profile",
  CTA_View_Membership = "CTA_View_Membership",
  SL_Settings = "SL_Settings",
  SL_Settings_Done = "SL_Settings_Done",
  SL_Memberships = "SL_Memberships",
  SL_Memberships_Done = "SL_Memberships_Done",
  CTA_Notification = "CTA_Notification",
  SL_Notification = "SL_Notification",
  SL_Notification_Done = "SL_Notification_Done",
  CTA_SMS = "CTA_SMS",
  CTA_Email = "CTA_Email",
  CTA_Whatsapp = "CTA_Whatsapp",
  CTA_Support = "CTA_Support",
  SL_Support = "SL_Support",
  SL_Support_Done = "SL_Support_Done",
  CTA_AboutUs = "CTA_AboutUs",
  CTA_TnC = "CTA_TnC",
  CTA_PrivacyPolicy = "CTA_PrivacyPolicy",
  CTA_FAQ = "CTA_FAQ",
  CTA_Feedback_Query = "CTA_Feedback_Query",
  CTA_Hotline = "CTA_Hotline",
  CTA_WriteUs = "CTA_WriteUs",
  SL_AboutUs = "SL_AboutUs",
  SL_AboutUs_Done = "SL_AboutUs_Done",
  SL_TnC = "SL_TnC",
  SL_TnC_Done = "SL_TnC_Done",
  SL_PrivacyPolicy = "SL_PrivacyPolicy",
  SL_PrivacyPolicy_Done = "SL_PrivacyPolicy_Done",
  SL_FAQ = "SL_FAQ",
  SL_FAQ_Done = "SL_FAQ_Done",
  SL_Hotline = "SL_Hotline",
  SL_Hotline_Done = "SL_Hotline_Done",
  SL_WriteUs = "SL_WriteUs",
  SL_WriteUs_Done = "SL_WriteUs_Done",
  ONPG_Message = "ONPG_Message",
  CTA_Send = "CTA_Send",
  CTA_Call = "CTA_Call",
  CTA_Whatsapp_Message = "CTA_Whatsapp_Message",
  CTA_Currency_Change = "CTA_Currency_Change",
  CTA_Account = "CTA_Account",
  SL_Account = "SL_Account",
  SL_Account_Done = "SL_Account_Done",
  SL_Profile = "SL_Profile",
  SL_Profile_Done = "SL_Profile_Done",
  CTA_Email_Verify = "CTA_Email_Verify",
  CTA_Mobile_Verify = "CTA_Mobile_Verify",
  ONPG_DOB = "ONPG_DOB",
  ONPG_Gender = "ONPG_Gender",
  CTA_Cancel = "CTA_Cancel",
  CTA_Save = "CTA_Save",
  CTA_Delete_Account = "CTA_Delete_Account",
  CTA_App_Store = "CTA_App_Store",
  CTA_Play_Store = "CTA_Play_Store",
  CTA_Registration = "CTA_Registration",
  Registration = "Registration",
  SL_Landing_Page = "SL_Landing_Page",
  SL_Landing_Page_Done = "SL_Landing_Page_Done",
  SL_Login_Register = "SL_Login_Register",

  SL_Homepage = "SL_Homepage",
  CLK_Card_homepg = "CLK_Card_homepg",
  CLK_Category_homepg = "CLK_Category_homepg",
  CLK_BKMR_homepg = "CLK_BKMR_homepg",
  SL_Explorepg = "SL_Explorepg",
  CLK_Category_explorepg = "CLK_Category_explorepg",
  CLK_openfilter_explorepg = "CLK_openfilter_explorepg",
  CLK_Filter_explorepg = "CLK_Filter_explorepg",
  CLK_sort_explorepg = "CLK_sort_explorepg",
  CLK_Card_explorepg = "CLK_Card_explorepg",
  CLK_BKMR_explorepg = "CLK_BKMR_explorepg",
  SL_nofilterpg = "SL_nofilterpg",
  CTA_remove_filter = "CTA_remove_filter",
  CLK_filterpg_distance = "CLK_filterpg_distance",
  CLK_filterpg_ratings = "CLK_filterpg_ratings",
  CLK_filterpg_cities = "CLK_filterpg_cities",
  CLK_filterpg_morefilters = "CLK_filterpg_morefilters",
  CLK_filterpg_clear = "CLK_filterpg_clear",
  CTA_filterpg_apply = "CTA_filterpg_apply",
  SL_detailpg = "SL_detailpg",
  CLK_bkmr_detailpg = "CLK_bkmr_detailpg",
  CLK_back_detailpg = "CLK_back_detailpg",
  CLK_open_detailpg = "CLK_open_detailpg",
  CLK_TnC_detailpg = "CLK_T&C_detailpg",
  CTA_getdirection = "CTA_getdirection",
  SCR_offer_detailpg = "SCR_offer_detailpg",
  CTA_call_detailpg = "CTA_call_detailpg",
  CLK_review_detailpg = "CLK_review_detailpg",
  CLK_support_detailpg = "CLK_support_detailpg",
  SL_ratingpg = "SL_ratingpg",
  CLK_stars_ratingpg = "CLK_stars_ratingpg",
  CLK_review_ratingpg = "CLK_review_ratingpg",
  CLK_adphoto_detailpg = "CLK_adphoto_detailpg",
  CLK_close_ratingpg = "CLK_close_ratingpg",
  CTA_submit_ratingpg = "CTA_submit_ratingpg",
  SL_supportpg = "SL_supportpg",
  CLK_text_supportpg = "CLK_text_supportpg",
  CLK_close_supportpg = "CLK_close_supportpg",
  CTA_submit_supportpg = "CTA_submit_supportpg",
  CLK_callnumber1_enquiry = "CLK_callnumber1_enquiry",
  CLK_callnumber2_enquiry = "CLK_callnumber2_enquiry",

  SL_Airport_Transfer = "SL_Airport_Transfer",
  SL_Airport_Transfer_Done = "SL_Airport_Transfer_Done",
  CLK_Pickup = "CLK_Pickup",
  CLK_Drop = "CLK_Drop",
  CLK_Swap_Location = "CLK_Swap_Location",
  CLK_Recent_Search = "CLK_Recent_Search",
  CLK_Search_Results = "CLK_Search_Results",
  CLK_Servicable_Airports = "CLK_Servicable_Airports",
  CLK_Date_Change = "CLK_Date_Change",
  CTA_Continue = "CTA_Continue",
  CTA_Previous = "CTA_Previous",
  CLK_Flight_Number = "CLK_Flight_Number",
  CLK_Cartype_Change = "CLK_Cartype_Change",
  CLK_Tooltip_NumberOfAdults = "CLK_Tooltip_NumberOfAdults",
  CLK_Tooltip_NumberOfBabies = "CLK_Tooltip_NumberOfBabies",
  CLK_Tooltip_NumberOfInfants = "CLK_Tooltip_NumberOfInfants",
  CLK_Tooltip_NumberOfLuggages = "CLK_Tooltip_NumberOfLuggages",
  Flight_Number_Success = "Flight_Number_Success",
  Flight_Number_Failed = "Flight_Number_Failed",
  CTA_Confirm = "CTA_Confirm",
  Booking_Failed = "Booking_Failed",
  Booking_Init = "Booking_Init",
  SL_Booking_Details_Start = "SL_Booking_Details_Start",
  SL_Booking_Details_Done = "SL_Booking_Details_Done",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
  CTA_Booking_For_Someone = "CTA_Booking_For_Someone",
  CTA_Continue_Step1 = "CTA_Continue_Step1",
  CTA_Continue_Step2 = "CTA_Continue_Step2",
  CTA_Previous_Step1 = "CTA_Previous_Step1",
  CTA_Previous_Step2 = "CTA_Previous_Step2",
  CLK_Booking_For_Myself = "CLK_Booking_For_Myself",
  CLK_Booking_For_Someone_Else = "CLK_Booking_For_Someone_Else",
  CLK_Confirm_Booking_For_Myself_Guest = "CLK_Confirm_Booking_For_Myself_Guest",
  CLK_Cancel_Booking_For_Myself_Guest = "CLK_Cancel_Booking_For_Myself_Guest",
  CTA_Delete_Guest = "CTA_Delete_Guest",
}
